import React from 'react'
import { BodyText, Button, HeadingText } from '@paypalcorp/pp-react'
import { useApplicationContext } from '../../../context/ApplicationContext'

function AccessGranted({ acceptedInvited, closeSheet }) {
  const { logger } = useApplicationContext()
  let payload

  try {
    payload = JSON.parse(
      acceptedInvited?.application_context?.transaction_payload || '{}',
    )
  } catch (error) {
    logger.error('Error parsing JSON payload:' + error)
    payload = {}
  }
  let invitingBusinessName = payload?.invitingBusinessName

  return (
    <>
      <div
        style={{
          marginBottom: '10px',
          paddingLeft: '15px',
          paddingRight: '15px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <img
            src="https://www.paypalobjects.com/paypal-ui/pictograms/blue/svg/partner-integration-blue.svg"
            alt="partner-integration"
            style={{ width: '100px' }}
          />
          <HeadingText
            size="sm"
            style={{ marginTop: '10px', textAlign: 'center' }}
          >
            And you're in
          </HeadingText>
          <BodyText style={{ marginTop: '20px', textAlign: 'center' }}>
            You have access to {invitingBusinessName} account as a developer.
            You can switch between your accounts anytime.
          </BodyText>
          <Button
            secondary
            onClick={() => closeSheet()}
            data-dxa="return_home_page,redirect,return_home_page"
            data-testid="returnHomePage"
          >
            Return to Home Page
          </Button>
        </div>
      </div>
    </>
  )
}

export default AccessGranted
